import { render, staticRenderFns } from "./SellerLocationForm.vue?vue&type=template&id=b44ba314&scoped=true&"
import script from "./SellerLocationForm.vue?vue&type=script&lang=ts&"
export * from "./SellerLocationForm.vue?vue&type=script&lang=ts&"
import style0 from "./SellerLocationForm.vue?vue&type=style&index=0&id=b44ba314&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44ba314",
  null
  
)

export default component.exports